import { z } from 'zod'

export const registersSubject = z.tuple([
  z.literal('access'),
  z.literal('Registers'),
])

export type RegistersSubject = z.infer<typeof registersSubject>
